
import React from 'react';
import FadeIn from '../../components/FadeIn';
import SEO from '../../components/SEO';

const GdprCompliance = () => {
    return (
        <div className="bg-white pt-32 pb-20 px-4 sm:px-6 lg:px-8">
            <SEO title="GDPR Compliance | BPO Consultants" description="Our compliance with the General Data Protection Regulation." />
            <FadeIn className="max-w-4xl mx-auto">
                <h1 className="text-4xl font-bold text-[#20222D] mb-8">GDPR Compliance</h1>
                <div className="prose prose-lg text-gray-600">
                    <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
                    <p className="mb-6">BPO Consultants is committed to ensuring the protection of data for our users and complying with the General Data Protection Regulation (GDPR).</p>

                    <h2 className="text-2xl font-bold text-[#20222D] mt-8 mb-4">1. Your Rights</h2>
                    <p className="mb-4">Under GDPR, you have the following rights regarding your personal data:</p>
                    <ul className="list-disc pl-6 mb-4 space-y-2">
                        <li>The right to access your personal data</li>
                        <li>The right to rectification of inaccurate data</li>
                        <li>The right to erasure ("right to be forgotten")</li>
                        <li>The right to restrict processing</li>
                        <li>The right to data portability</li>
                        <li>The right to object to processing</li>
                    </ul>

                    <h2 className="text-2xl font-bold text-[#20222D] mt-8 mb-4">2. Data Processing</h2>
                    <p className="mb-4">We process personal data only when we have a lawful basis to do so, such as your consent, contractual necessity, or legitimate interests.</p>

                    <h2 className="text-2xl font-bold text-[#20222D] mt-8 mb-4">3. Data Transfer</h2>
                    <p className="mb-4">If we transfer your personal data outside the European Economic Area (EEA), we ensure that appropriate safeguards are in place to protect your data.</p>

                    <h2 className="text-2xl font-bold text-[#20222D] mt-8 mb-4">4. Contact DPO</h2>
                    <p className="mb-4">To exercise your rights or for any GDPR-related inquiries, please contact our Data Protection Officer at info@bpoconsultants.ph.</p>
                </div>
            </FadeIn>
        </div>
    );
};

export default GdprCompliance;
